import React from 'react';
import TPPolarisTable from './TPPolarisTable';
import 'src/assets/styles/react-table.scss';

interface TPPolarisTableWithErrorHighlightProps extends React.ComponentProps<typeof TPPolarisTable> {
  // Inherits all TPPolarisTable props
}

export default function TPPolarisTableWithErrorHighlight(props: TPPolarisTableWithErrorHighlightProps) {
  const { columnDefinitions, ...restProps } = props;
  
  const enhancedColumnDefinitions = React.useMemo(() => {
    return columnDefinitions.map(col => ({
      ...col,
      cell: (item: any) => {
          const originalCellRenderer = col.cell ?? ((item: any) => item[col.id || '']);
          const originalCell = originalCellRenderer(item);
          const hasError = item.errors && item.errors instanceof Map && item.errors.has(col.id);
          const errorMessage = hasError ? item.errors.get(col.id) : '';

          return hasError ? (
              <div data-tip={errorMessage} className="errorHighlightCell">
                  {originalCell || '\u00A0'}
              </div>
          ) : originalCell;
      }
    }));
  }, [columnDefinitions]);

  return (
    <div className="tpPolarisTableWithErrorHighlight">
      <TPPolarisTable
        {...restProps}
        columnDefinitions={enhancedColumnDefinitions}
      />
    </div>
  );
}
